
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'


export default {
components: {
XHeader,
Group,
Cell,
Actionsheet
},
data() {
return {
paperList: [],
currentPaper: {},
showMenu: false,
menuType: {
type1: "开始考试",
type2: "查看解析",
type3: "删除试卷"
}
};
},
created() {
this.getdate();
},
methods: {
getdate() {
this.$vux.loading.show({
text: "请稍候..."
});

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadPaperList",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
this.paperList = response.data.data;
}
this.$vux.loading.hide();
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
});
},
buildPaper() {
this.$router.push({
path: "/BuildPaper",
query: { paperCount: this.paperList.length }
});
},
clickPaper(paper) {
this.currentPaper = paper;
this.showMenu = true;
},
clickMenu(menuKey, menuItem) {
if (menuKey == "type1") {
this.$router.push({
path: "/SubjuectData",
query: {
showtime: this.GLOBAL.SubjectShowTime.Examination,
examshowtime: this.GLOBAL.ExamShowTime.Exam,
paperId: this.currentPaper.ipaperid
}
});
} else if (menuKey == "type2") {
this.$router.push({
path: "/SubjuectData",
query: {
showtime: this.GLOBAL.SubjectShowTime.View,
examshowtime: this.GLOBAL.ExamShowTime.View,
paperId: this.currentPaper.ipaperid
}
});
} else if (menuKey == "type3") {
const _this = this;
this.$vux.confirm.show({
title: "删除试卷",
content: "确定要删除试卷吗？删除后无法恢复！",
onConfirm() {
_this
.$http({
method: "post",
url: "wxexam.ashx?op=DeletePaper",
params: {
paperId: _this.currentPaper.ipaperid
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
_this.$vux.toast.text("删除试卷成功", "bottom");
_this.getdate();
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
});
}
}
},
computed: {
viewHeight: function() {
return document.documentElement.clientHeight - 46;
},
paperCount: function() {
return this.paperList.length;
}
}
};



// WEBPACK FOOTER //
// ./src/components/SimulationTest.vue